import { render, staticRenderFns } from "./DiscardedInfractionsReport.vue?vue&type=template&id=70389561&scoped=true"
import script from "./DiscardedInfractionsReport.js?vue&type=script&lang=js&external"
export * from "./DiscardedInfractionsReport.js?vue&type=script&lang=js&external"
import style0 from "./DiscardedInfractionsReport.vue?vue&type=style&index=0&id=70389561&prod&scoped=true&lang=scss"
import style1 from "./DiscardedInfractionsReport.vue?vue&type=style&index=1&id=70389561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70389561",
  null
  
)

export default component.exports